const assetsBaseUrl = (import.meta.env.VITE_ASSETS_BASE_URL || '').replace(
  /\/$/,
  '',
);

export const fallbackImageUrl =
  'https://images.fineartamerica.com/images/artworkimages/mediumlarge/3/retro-tv-test-pattern-marianna-mills.jpg';

export const getAssetUrl = (path?: string): string => {
  if (!path) return fallbackImageUrl;
  if (/^https?:\/\//i.test(path)) return path;
  return `${assetsBaseUrl}/${path.replace(/^\//, '')}`;
};
